import { normaliseMoneyAmount } from '../../helpers/presentation/normaliseMoneyAmount';

import type { Money } from '../../selectors/dealHunterTypes';

export const convertItineraryPriceToWhole = (
  price: Money | undefined,
): number | null => {
  const amount = normaliseMoneyAmount(price);

  return amount == null ? null : Math.round(amount);
};
